import {combineReducers} from 'redux';
import {generalReducer} from './generalReducer';
import {administrationReducer} from './adminstrationReducer';
import {approvalsReducer} from './approvalsReducer';
import {baseOptionReducer} from './baseOptionReducer';
import {derivateReducer} from './derivatesReducer';
import {dynTableReducer} from './dynTableReducer';
import {supportReducer} from './supportReducer';
import {technicalDataReducer} from './technicalDataReducer';
import {kumaReducer} from './kumaReducer';

const rootReducer = combineReducers({
  general: generalReducer,
  derivates: derivateReducer,
  baseOptions: baseOptionReducer,
  administration: administrationReducer,
  technicalData: technicalDataReducer,
  support: supportReducer,
  approvals: approvalsReducer,
  dynTable: dynTableReducer,
  kuma: kumaReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/rootReducer.ts